import React from "react";
import IPage from "../../interfaces/page"
import InactiveClientsComponent from "../../components/InactiveClients/InactiveClients.component";

const InactiveClientsPage: React.FunctionComponent<IPage> = (props: IPage) => {
    return <InactiveClientsComponent></InactiveClientsComponent>;
};

export default InactiveClientsPage;
